import { Heat, HeatConfig } from "graphql/generated/types";
import { Modifier } from "../components/events/judging/modifiers/Modifier";
import { FormattedTotal } from "./FormattedTotal";

export type ResultModel = ReturnType<typeof Result>;

export const Result = <
    T extends Pick<Heat["result"][number], "total" | "place" | "rides">,
>(
    result: T,
) => ({
    ...result,
    getModifier(includePending?: boolean) {
        return Object.values(result.rides || {})
            .map(
                (athleteRides) =>
                    athleteRides
                        .filter(
                            (ride: any) =>
                                (includePending || !ride.pending) &&
                                ride.modifier,
                        )
                        .sort(
                            (a: any, b: any) =>
                                ["DNF", "DSQ", "DNS"].indexOf(
                                    a.modifier.type.split("::")[1],
                                ) -
                                ["DNF", "DSQ", "DNS"].indexOf(
                                    b.modifier.type.split("::")[1],
                                ),
                        )?.[0],
            )
            .filter((m) => m)[0]?.modifier;
    },
    placeToDisplay(includePending?: boolean) {
        const modifier = this.getModifier(includePending);
        const modifierClass = modifier?.type.split("::")?.[1];
        const didNotModifier = modifierClass?.match(/D(N|S)(S|F|Q)/);

        if (result.total > 0)
            return { place: result.place, type: "place" as const };
        if (didNotModifier)
            return {
                // @ts-expect-error not yet converted to TS
                place: <Modifier modifier={modifier} />,
                type: "modifier" as const,
            };
        return { place: "-", type: "unscored" as const };
    },
    formattedTotal(config: Pick<HeatConfig, "calculator">) {
        return FormattedTotal(result.total, config);
    },
});
